<template>
  <main class="main" v-show="!isLoading">
    <div class="auth-container">
      <div class="auth-wrapper" :class="{
        'has-flash-msg': hasFlashMsg,
        }
    ">
        <div v-if="hasFlashMsg" class="auth-wrapper__notification">
          <slot name="flashMsg" />
        </div>

        <slot name="body" />
      </div>
      <div class="auth-footer">
        {{ $t("transaction-flow.shared.secured") }}
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'AuthWrapper',

  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    hasFlashMsg() {
      return !!this.$slots.flashMsg;
    },
  },
};
</script>

<style scoped lang="scss">
.auth-container {
  margin: rem(24) 0 rem(40);
  padding: 0 rem(24);

  @media screen and (min-width: $screen-lg-min) {
    margin: rem(64) 0 rem(80);
  }
}

.auth-wrapper {
  background-color: $white;
  border-radius: rem(10);
  width: rem(454);
  max-width: 100%;
  margin: 0 auto;

  &__icon-container {
    padding: rem(84) 0 rem(79) 0;
    text-align: center;
  }

  &__icon-container .auth-icon {
    display: block;
    width: rem(118);
    height: rem(76);
    margin: 0 auto;
  }

  &__header {
    padding: 0 rem(24) rem(22) rem(24);
  }

  &__header .auth-title {
    font-family: $font-bold;
    font-size: rem(24);
    line-height: 1.17;
    text-align: center;
    word-break: break-word;
  }

  &__msg {
    font-family: $font-bold;
    font-size: rem(16);
    line-height: 1.75;
    text-align: center;
  }

  &__form {
    margin-top: rem(14);
    padding: 0 rem(24) rem(40) rem(32);
  }

  &__footer {
    margin-top: rem(70);
    padding-bottom: rem(22);
    text-align: center;
  }

  &__footer .btn-link {
    font-family: $font-bold;
    font-size: rem(16);
    line-height: 1.25;
  }

  ::v-deep & .auth-row + .auth-row {
    margin-top: rem(16);
  }

  ::v-deep & .auth-row + .auth-row--dm {
    margin-top: rem(32);
  }

  @media screen and (min-width: $screen-lg-min) {
    &__header {
      padding: rem(24) rem(52) rem(22) rem(52);
    }

    &__form {
      margin-top: rem(14);
      padding: 0 rem(52) rem(40) rem(52);
    }
  }
}

.auth-footer {
  text-align: center;
  margin-top: rem(16);
  font-size: rem(14);
  line-height: 1.14;

  @media screen and (min-width: $screen-lg-min) {
    margin-top: rem(24);
  }
}
</style>
